module.exports = new __parcel__URL__("jira-laptop-done.35194f30.svg").toString();